var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextsizesmall = function SvgTextsizesmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.3l-.7-1.7h-4l-.6 1.7H4.4l3.5-8.9h2l3.4 8.9h-1.8zM8.9 9.1l-1.6 4.2h3.2L8.9 9.1zm9.2 7.2v-.6c-.4.6-1.2.8-2 .8-1 0-2.2-.8-2.2-2.2 0-1.5 1.2-2 2.2-2 .8 0 1.6.3 2 .8v-1c0-.7-.6-1.2-1.5-1.2-.8 0-1.3.3-1.9.8l-.6-.9c.8-.8 1.7-1 2.7-1 1.4 0 2.7.6 2.7 2.3v4.2h-1.4zm0-1.4v-1c-.3-.4-.9-.6-1.5-.6-.8 0-1.4.5-1.4 1.1s.6 1.1 1.4 1.1c.6 0 1.2-.2 1.5-.6z"
  })));
};
export { SvgTextsizesmall as ReactComponent };